import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getApplicationQueryKey } from '@/components/candidate-job-slider-v1/hooks/useApplicationHelper';
import { triggerExecutionsBulk } from './workflowExecutions.api';
import type { UnderwayActivity } from './types';

// Fires the BE `bulk_trigger` endpoint for the activity's pending
// executions. The move itself happened earlier (at confirm time) —
// the row only tracks the 15s "trigger or cancel" window.
export const useUnderwayDispatcher = () => {
  const queryClient = useQueryClient();

  const fire = useCallback(
    async (activity: UnderwayActivity): Promise<void> => {
      if (activity.executionIds.length === 0) {
        throw new Error('No pending executions to trigger');
      }
      await triggerExecutionsBulk(activity.executionIds);

      // Refresh candidate list + every drawer pinned to one of these
      // applications so the freshly-triggered automation surfaces in
      // the activity timeline. The candidate already moved at confirm
      // time, so these refetches mainly pull in the new stage_actions
      // /next_action info.
      if (activity.jobId) {
        queryClient.invalidateQueries({
          queryKey: ['getCandidateList', Number(activity.jobId)],
        });
      }
      activity.candidates.forEach((c) => {
        queryClient.invalidateQueries({
          queryKey: getApplicationQueryKey(String(c.id)),
        });
      });
    },
    [queryClient]
  );

  return { fire };
};
